import { useContext } from "react";
import { SpotifyAuthContext } from "../context/SpotifyAuthContext";

const useSpotifyAuth = () => useContext(SpotifyAuthContext);

export default useSpotifyAuth;
